import React from "react";
import { inject, observer } from "mobx-react";
import { ProposalStore } from "../../../stores/proposalStore";
import { CalculateStore } from "../../../stores/calculateStore";
import Senior from "./senior";

interface SafeSeniorProps {
  proposalStore?: ProposalStore;
  calculateStore?: CalculateStore;
}

@inject("proposalStore", "calculateStore")
@observer
export default class SafeSenior extends React.Component<SafeSeniorProps> {

  public render() {
    return (
      <>
        {this.isSafeSeniorInsured() && (
          <div className="safe-senior">
            {this.renderErrorMessage()}
            {this.renderSafeSenior()}
          </div>
        )}
      </>
    );
  }

  private isSafeSeniorInsured(): boolean {
    return this.props.calculateStore!.additionalInsurances.safeSenior.checked;
  }

  private numberOfSafeSeniorClients() {
    return Number(this.props.calculateStore!.additionalInsurances.safeSenior.safeSeniorCount);
  }

  private renderErrorMessage() {
    return (<div>
      {this.shouldRenderPeselDuplicationError() && this.renderPeselDuplicationError()}
    </div>);
  }

  private shouldRenderPeselDuplicationError() {
    return this.props.proposalStore!.safeSenior.safeSeniorClientsDulicate;
  }

  private renderPeselDuplicationError() {
    return (
      <div className="error-message">
        Numery PESEL nie mogą się powtarzać
      </div>
    );
  }

  private renderSafeSenior() {
    const container: JSX.Element[] = [];

    for (let i = 0, numberOfClients = this.numberOfSafeSeniorClients(); i < numberOfClients; i++) {
      const headerText = numberOfClients === 1 ? `Ubezpieczony w Bezpieczny Senior` : `Ubezpieczony w Bezpieczny Senior (${i + 1})`;

      container.push(
        <Senior
          key={`safe-senior-${i}`}
          senior={this.props.proposalStore!.safeSenior.seniors[i]}
          headerText={headerText} />
      );
    }

    return container;
  }
}
